export const BUY_ME_A_COFFEE_URL = 'https://buymeacoffee.com/jdafforn'

export const Feedback = () => {
  return (
    <>
      <div className="flex justify-between gap-4 py-3">
        <a
          href={BUY_ME_A_COFFEE_URL}
          className="mt-2 rounded-lg border-2 border-solid border-indigo-500/100 p-2 text-left text-indigo-500/100 dark:text-gray-300"
        >
          Buy Me A Coffee ☕️
        </a>
      </div>
    </>
  )
}
